/**
 * Permission codenames matching Django auth permissions.
 * Used for UI visibility; backend always enforces via has_perm().
 *
 * AUTO-GENERATED from wrapper/authentication/constants.py
 * Do not edit manually. Run: python scripts/generate_permissions.py
 *
 * Format: app_label.codename (e.g. api.view_annotation)
 */
export const PERMISSIONS = Object.freeze({
    // Annotations
    ANNOTATION_VIEW: 'api.view_annotation',
    ANNOTATION_ADD: 'api.add_annotation',
    ANNOTATION_CHANGE: 'api.change_annotation',
    ANNOTATION_DELETE: 'api.delete_annotation',
    // Snapshots (DataSetTask)
    SNAPSHOT_VIEW: 'api.view_datasettask',
    SNAPSHOT_ADD: 'api.add_datasettask',
    SNAPSHOT_CHANGE: 'api.change_datasettask',
    SNAPSHOT_DELETE: 'api.delete_datasettask',
    // Workflow — built-in CRUD (capability-style perms are in PERMS_CUSTOM)
    WORKFLOW_VIEW_REGISTRY: 'workflow.view_registry',
    WORKFLOW_ADD_REGISTRY: 'workflow.add_registry',
    WORKFLOW_CHANGE_REGISTRY: 'workflow.change_registry',
    WORKFLOW_DELETE_REGISTRY: 'workflow.delete_registry',
    WORKFLOW_VIEW_INSTRUCTION: 'workflow.view_instruction',
    WORKFLOW_ADD_INSTRUCTION: 'workflow.add_instruction',
    WORKFLOW_CHANGE_INSTRUCTION: 'workflow.change_instruction',
    WORKFLOW_DELETE_INSTRUCTION: 'workflow.delete_instruction',
    WORKFLOW_VIEW_GUIDELINE: 'workflow.view_guideline',
    WORKFLOW_ADD_GUIDELINE: 'workflow.add_guideline',
    WORKFLOW_CHANGE_GUIDELINE: 'workflow.change_guideline',
    WORKFLOW_DELETE_GUIDELINE: 'workflow.delete_guideline',
    WORKFLOW_VIEW_BATCH: 'workflow.view_batch',
    WORKFLOW_ADD_BATCH: 'workflow.add_batch',
    WORKFLOW_CHANGE_BATCH: 'workflow.change_batch',
    WORKFLOW_DELETE_BATCH: 'workflow.delete_batch',
    WORKFLOW_VIEW_ROUND: 'workflow.view_round',
    WORKFLOW_ADD_ROUND: 'workflow.add_round',
    WORKFLOW_CHANGE_ROUND: 'workflow.change_round',
    WORKFLOW_DELETE_ROUND: 'workflow.delete_round',
    WORKFLOW_VIEW_ANNOTATION_TASK: 'workflow.view_annotationtask',
    WORKFLOW_ADD_ANNOTATION_TASK: 'workflow.add_annotationtask',
    WORKFLOW_CHANGE_ANNOTATION_TASK: 'workflow.change_annotationtask',
    WORKFLOW_DELETE_ANNOTATION_TASK: 'workflow.delete_annotationtask',
    WORKFLOW_VIEW_ANNOTATIONTASKCOMMENT: 'workflow.view_annotationtaskcomment',
    WORKFLOW_ADD_ANNOTATIONTASKCOMMENT: 'workflow.add_annotationtaskcomment',
    WORKFLOW_CHANGE_ANNOTATIONTASKCOMMENT: 'workflow.change_annotationtaskcomment',
    WORKFLOW_DELETE_ANNOTATIONTASKCOMMENT: 'workflow.delete_annotationtaskcomment',
    WORKFLOW_VIEW_WORKFLOWEVENT: 'workflow.view_workflowevent',
    // Stats
    STATS_VIEW: 'api.view_metric',
    // Information (CRUD defaults on ``Information``)
    INFORMATION_VIEW: 'api.view_information',
    INFORMATION_CHANGE: 'api.change_information',
    INFORMATION_ADD: 'api.add_information',
    // Annotations
    ANNOTATION_RESTORE: 'api.restore_annotation',
    ANNOTATION_REVIEW: 'api.review_annotation',
    ANNOTATION_CAT_UPLOAD: 'api.cat_annotation_upload',
    EVENT_VIEW: 'api.view_events',
    // Snapshots (DataSetTask)
    SNAPSHOT_RERUN: 'api.rerun_dataset',
    // Information
    INFORMATION_UPDATE: 'api.update_information',
    // Data Readiness
    DATAREADINESS_VIEW: 'api.datareadiness_view',
    DATAREADINESS_MANAGE: 'api.datareadiness_manage',
    DATAREADINESS_ADMIN: 'api.datareadiness_admin',
    // Workflow — custom Meta.permissions (see ``workflow/permissions/definitions.py``)
    WORKFLOW_RESET_METADATA: 'workflow.reset_metadata',
    WORKFLOW_IMPORT_ROUND_CSV: 'workflow.import_round_csv',
    WORKFLOW_DELETE_EMPTY_BATCH: 'workflow.delete_empty_batch',
    WORKFLOW_DELETE_DRAFT_ROUND: 'workflow.delete_draft_round',
    WORKFLOW_EDIT_METADATA_SCHEMA: 'workflow.edit_metadata_schema',
    WORKFLOW_IMPORT_METADATA_CSV: 'workflow.import_metadata_csv',
    WORKFLOW_APPLY_ROUND: 'workflow.apply_round',
    WORKFLOW_MARK_ROUND_DONE: 'workflow.mark_round_done',
    WORKFLOW_FORCE_REFRESH_ROUND_STATUS: 'workflow.force_refresh_round_status',
    WORKFLOW_IMPORT_ROUND_TO_MIMIR: 'workflow.import_round_to_mimir',
    WORKFLOW_ASSIGN_ROUND_USERS: 'workflow.assign_round_users',
    WORKFLOW_UPGRADE_GUIDELINE: 'workflow.upgrade_guideline',
    WORKFLOW_EDIT_TASK_METADATA: 'workflow.edit_task_metadata',
    WORKFLOW_IMPORT_TASK_TO_MIMIR: 'workflow.import_task_to_mimir',
    WORKFLOW_VERIFY_TASK: 'workflow.verify_task',
    WORKFLOW_UPDATE_STATUS_BY_JOB_ID: 'workflow.update_status_by_job_id',
    WORKFLOW_MARK_JOB_DELETED: 'workflow.mark_job_deleted',
    WORKFLOW_REMOVE_ORPHANED_TASK: 'workflow.remove_orphaned_task',
    WORKFLOW_MANAGE_TASK_COMMENTS: 'workflow.manage_task_comments',
    WORKFLOW_EDIT_INSTRUCTION_OVERRIDES: 'workflow.edit_instruction_overrides',
    WORKFLOW_CHANGE_BATCH_MANAGERS: 'workflow.change_batch_managers',
    WORKFLOW_ADD_MANAGER_COMMENT: 'workflow.add_manager_comment',
    WORKFLOW_EXPORT_ROUNDS_REPORT: 'workflow.export_rounds_report',
    WORKFLOW_METRICS_VIEW: 'workflow.view_metrics',
});
